var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeBackgroundCropped(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    viewBox: "25 0 161.33 100.12",
    preserveAspectRatio: "none",
    "grid-area": "main",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".af8e181a-0d1e-442c-8435-71280c7f0c55{fill:none;}.bbb6d1ed-78e4-4070-a1b7-d168ab191c82{clip-path:url(#a8280197-0cbd-4507-af71-c5f7f3f1a3e4);}.a37481f7-84be-46cb-a2e8-4d52cab77671{fill:#5090bd;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a8280197-0cbd-4507-af71-c5f7f3f1a3e4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "af8e181a-0d1e-442c-8435-71280c7f0c55",
    width: 161.33,
    height: 100.12
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b5f0001d-5e77-4b7c-bdc7-787b4bfd3174",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ea9e84cc-5677-4024-b95a-0689d42b8556",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbb6d1ed-78e4-4070-a1b7-d168ab191c82"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a37481f7-84be-46cb-a2e8-4d52cab77671",
    d: "M0,0V108.62a9.27,9.27,0,0,0,9.14,9.26l111.66,1.38a9.25,9.25,0,0,0,8.6-5.56l31.16-71.44a9.25,9.25,0,0,0-5.42-12.43L63.72-2.37a9.26,9.26,0,0,0-1.94-.45L10.4-9.19A9.26,9.26,0,0,0,0,0Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBackgroundCropped);
export default __webpack_public_path__ + "static/media/home_background_cropped.b3ac07b5dc79a6ba2ac848d52fdc92fc.svg";
export { ForwardRef as ReactComponent };